.card {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  min-width: 0;
  padding: var(--space-4) var(--space-5);
  background-color: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-xs);
}

.top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--space-3);
}

.label {
  color: var(--color-text-muted);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
}

.icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: var(--metric-tone);
}

.icon > svg {
  width: 1.75rem;
  height: 1.75rem;
}

/* Tones color the icon. */
.primary {
  --metric-tone: var(--color-link);
}

.info {
  --metric-tone: var(--color-info-fg);
}

.success {
  --metric-tone: var(--color-success-fg);
}

.warning {
  --metric-tone: var(--color-warning-fg);
}

.danger {
  --metric-tone: var(--color-danger-fg);
}

.special {
  --metric-tone: var(--color-special-fg);
}

.accent {
  --metric-tone: var(--color-accent-fg);
}

.value {
  color: var(--color-heading);
  font-size: var(--font-size-3xl);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-tight);
  font-variant-numeric: tabular-nums;
  letter-spacing: var(--letter-spacing-tight);
}

.meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-1-5) var(--space-2);
  font-size: var(--font-size-sm);
}

.delta {
  display: inline-flex;
  align-items: center;
  gap: var(--space-0-5);
  padding: 0.0625rem var(--space-1-5);
  border-radius: var(--radius-sm);
  font-weight: var(--font-weight-semibold);
  font-variant-numeric: tabular-nums;
}

.delta.positive {
  background-color: var(--color-success-bg);
  color: var(--color-success-fg);
}

.delta.negative {
  background-color: var(--color-danger-bg);
  color: var(--color-danger-fg);
}

.delta.neutral {
  background-color: var(--color-neutral-bg);
  color: var(--color-neutral-fg);
}

.deltaLabel,
.help {
  color: var(--color-text-subtle);
}

.loading {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}
